module.exports = __webpack_public_path__ + "static/recipe-phone-dc81417ae0c748c507b552b09f316f7c.jpg";